<template>
  <section>
    <form class="topup-form" @submit.prevent="submit">
      <div class="topup-form-frame">
        <div class="topup-loading" v-if="!widgetAvailable">{{ $t('component.creditcard.loadingText') }}</div>
        <h1>{{ $t('component.creditcard.header') }}</h1>
        <p>{{ $t('component.creditcard.verifyText') }}</p>
        <div>
          <iframe ref="iframe"
                  title="iframe"
                  :src="getIframeSrc()"
                  @load="onIframeLoaded">
          </iframe>
        </div>
        <div class="topup-description">
          <p v-html="$t('component.creditcard.descriptionText')"></p>
        </div>
      </div>
      <div class="topup-form-buttons">
        <span></span>
        <button id="submit-credit-card" type="submit" :disabled="!widgetAvailable">{{ $t('component.creditcard.buttonNext') }} ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import CreditCardFormMixin from '@/common/mixins/CreditCard/Form.mixin'

export default {
  name: 'CreditCardForm',
  mixins: [CreditCardFormMixin]
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
